import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { FetchDirecta24OptionsRequest } from '@cashier/cashier-api-model';

import {
  fetchDirecta24OptionsFailure,
  fetchDirecta24OptionsStart,
  fetchDirecta24OptionsSuccess,
  fetchDynamicOptionsStart,
  fetchDynamicOptionsSuccess,
} from './paymentForm.slice';

export const fetchDirecta24OptionsEpic = (action$: any, state$: any, { Api }) =>
  action$.pipe(
    ofType(fetchDirecta24OptionsStart.type),
    switchMap((action: { payload: FetchDirecta24OptionsRequest }) =>
      Api.fetchDirecta24Options(action.payload).pipe(
        map((data: any) => fetchDirecta24OptionsSuccess(data)),
        catchError((err) => of(fetchDirecta24OptionsFailure(err))),
      ),
    ),
  );

export const fetchDirecta24Options = (data: FetchDirecta24OptionsRequest) => ({
  type: fetchDirecta24OptionsStart.type,
  payload: data,
});

export const fetchDynamicOptionsEpic = (action$, state$, { Api }) =>
  action$.pipe(
    ofType(fetchDynamicOptionsStart.type),
    switchMap((action: { payload: string }) =>
      fetch(action.payload)
        .then((res) => res.arrayBuffer())
        .then((res) => {
          const decoder = new TextDecoder('iso-8859-1');
          const { payload } = JSON.parse(decoder.decode(res));
          return fetchDynamicOptionsSuccess(payload);
        }),
    ),
  );

export const fetchDynamicOptions = (url: string) => ({
  type: fetchDynamicOptionsStart.type,
  payload: url,
});
